var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('p',[_vm._v("\n    Need help?\n    "),_c('br'),_c('TfCtaEmailSupport',{attrs:{"type":"primary","data-test":"contact support"}},[_vm._v("\n      Contact support\n    ")]),_vm._v(".\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }